export interface LandingPageFaq {
  question: string;
  answer: string;
}

export interface Review {
  ordinal: number;
  companyName: string;
  companySlug: string;
  companyLogos: {
    reviewCard?: string;
    footerCard?: string;
  };
  companyPhone?: string;
  valuesProps: string[];
  reviewScore: number;
  reviewLabel: string;
  optionType: string;
  ctas: {
    primary: {
      text: string;
      url: string;
    };
    sticky: {
      text: string;
      url: string;
    };
  };
  fullReviewHero?: string;
  fullReviewProps?: string[];
  sticky: boolean;
  infoTitle?: string;
  infoText?: string;
  paragraphs?: string[];
}
export interface FeatureItem {
  iconName: string;
  subtitle?: string;
  title: string;
}
export interface FeaturedHeroCards {
  title: string;
  subtitle: string;
  items: FeatureItem[];
}

export interface FeaturedHeroData {
  cards: FeaturedHeroCards;
  cta: {
    text: string;
    url: string;
  };
  fullReviewsSubtitle: string;
  fullReviewsTitle: string;
  image: string;
  items: FeatureItem[];
  note: string;
  subtitle: string;
  title: string;
}

export interface LandingPage {
  popupImage: string;
  landingPageTitle: string;
  landingPageDek: string;
  methodology?: {
    title: string;
    description: string;
  };
  defaultPhoneNumber: string;
  disclosure: {
    text: string;
    title: string;
  };
  primaryCta: {
    text: string;
    url: string;
  };
  footer: string;
  faqs: LandingPageFaq[];
  faqTitle?: string;
  featuredHero?: FeaturedHeroData;
  note?: string;
  reviews: Review[];
  topLandingPageTitle?: string;
  topLandingPageDek?: string;
  topCta?: {
    text: string;
    url: string;
  };
}

export interface Data {
  landingPages: {
    google: LandingPage;
    bing: LandingPage;
  };
}

export const ndrData: Data = {
  landingPages: {
    bing: {
      defaultPhoneNumber: '800-940-1328',
      disclosure: {
        text: 'The Parties acknowledge and agree that (i) the PPC Program Landing Page, and any related webpages as determined by Publisher in its sole and absolute discretion, shall feature a disclosure that states prominently that all Paid Content is “Paid Content”, with an “i” symbol linking to a further explanation, (a “Disclaimer”) and (ii) the placement, formatting and other wording associated with any Disclaimer shall be determined by Publisher in its sole and absolute discretion.',
        title: 'Paid Content',
      },
      faqs: [
        {
          answer:
            'Debt relief also typically replaces multiple monthly payments for one—but it focuses on reducing the principal balance by negotiating with your creditors directly. This can help you get out of debt significantly faster.',
          question: "What's the difference between debt relief and debt consolidation?",
        },
        {
          answer:
            'Debt relief can help you with unsecured debts. Balances on things like credit cards, personal loans, and lines of credit can potentially benefit from debt relief. Secured debt backed by collateral (think an auto loan backed by the vehicle, for example) typically is not eligible.',
          question: 'What types of debt can debt relief companies help with?',
        },
        {
          answer:
            "The debt relief process generally takes 48 months or less to complete, though specifics will depend on the details of an individual's situation.",
          question: 'How long does the debt relief process take?',
        },
        {
          answer:
            "It's possible to try to negotiate with creditors yourself, potentially saving some money in fees as you won't have to pay a company to do it for you. However, settling can be a tall task that benefits from professional help; and you may not be able to negotiate as good of an offer as an established debt relief company with professional negotiators.",
          question: 'Can I negotiate with creditors myself instead of using a debt relief company?',
        },
      ],
      faqTitle: 'Debt Relief FAQ’s',
      featuredHero: {
        cards: {
          items: [
            {
              iconName: 'creditCard',
              title: 'Credit Cards',
            },
            {
              iconName: 'squareLibrary',
              title: 'Collections',
            },
            {
              iconName: 'banknoteArrowUp',
              title: 'Lines of Credit',
            },
            {
              iconName: 'handCoins',
              title: 'Personal Loans',
            },
            {
              iconName: 'landmark',
              title: 'Repossessions',
            },
            {
              iconName: 'hospital',
              title: 'Medical Bills',
            },
          ],
          subtitle: 'Most unsecured debt may be eligible for a debt consolidation plan.',
          title: 'Debt You May Be Able to Get Help With',
        },
        cta: {
          text: 'Get Your Free Estimate',
          url: 'https://start.nationaldebtrelief.com/apply-loan',
        },
        fullReviewsSubtitle:
          'Lorem ipsum dolor sit amet consectetur. Fermentum gravida vulputate id odio est. Commodo amet nulla egestas felis adipiscing nam aliquet euismod.',
        fullReviewsTitle: 'Debt You May Be Able to Get Help With',
        image: '/static/ndr/featured-hero.jpeg',
        items: [
          {
            iconName: 'bookText',
            subtitle: 'There’s no obligation and you can explore options for your situation.',
            title: 'Submit the form to set up a free consultation with National Debt Relief',
          },
          {
            iconName: 'listTodo',
            subtitle: 'You’ll get an opportunity to review and approve the personalized plan.',
            title: 'National Debt Relief’s team builds a plan to fit your needs and budget',
          },
          {
            iconName: 'chartCandlestick',
            subtitle: 'You’ll get an opportunity to review and approve the personalized plan.',
            title: 'National Debt Relief’s team builds a plan to fit your needs and budget',
          },
        ],

        note: "On National Debt Relief's Website",
        subtitle: 'Connect with an expert and get the help you need',
        title: 'How Debt Consolidation Works',
      },
      footer:
        '<p>When looking for a reputable debt relief program, a good rule of thumb is to stick to members of the American Fair Credit Council (AFCC) or the International Associate of Professional Debt Arbitrators (IAPDA). These can be expected to abide by more rigid ethics and standards than those without such guardrails.</p><p>Debt relief may sound like a no-brainer—but these programs aren’t powered by magic. Also understand that your credit score may take a temporary hit, as most debt relief programs encourage you to stop paying on your loans as a way to gain leverage with the banks and lower your amount owed. It’s wise to pore over customer service reviews and rankings with sites like the Better Business Bureau. Some companies will also offer credit counseling upon request to help you find an alternative to debt relief.</p><p>*Clients who are able to stay with the program and get all their debt settled realize approximate savings of 45% before fees, or 20% including our fees, over 12 to 48 months. All claims are based on enrolled debts. Not all debts are eligible for enrollment. Not all clients complete our program for various reasons, including their ability to save sufficient funds. Estimates based on prior results, which will vary based on specific circumstances. We do not guarantee that your debts will be lowered by a specific amount or percentage or that you will be debt-free within a specific period of time. We do not assume consumer debt, make monthly payments to creditors or provide tax, bankruptcy, accounting or legal advice or credit repair services. Not available in all states. Please contact a tax professional to discuss tax consequences of settlement. Please consult with a bankruptcy attorney for more information on bankruptcy. Depending on your state, we may be available to recommend a local tax professional and/or bankruptcy attorney. Read and understand all program materials prior to enrollment, including potential adverse impact on credit rating.</p><p><i>* The Parties acknowledge and agree that (i) the PPC Program Landing Page, and any related webpages as determined by Publisher in its sole and absolute discretion, shall feature a disclosure that states prominently that all Paid Content is “Paid Content”, with an “i” symbol linking to a further explanation, (a “Disclaimer”) and (ii) the placement, formatting and other wording associated with any Disclaimer shall be determined by Publisher in its sole and absolute discretion.</i></p>',
      landingPageDek:
        '<p>Feeling weighed down by credit card balances, medical debt, or other monthly bills? You’re not alone. Debt can feel overwhelming, but the right relief program can help you regain control and simplify your payments. We reviewed leading debt consolidation programs to help you choose the right option for your financial situation.</p>',
      landingPageTitle: 'Best Debt Relief Programs of 2025',
      methodology: {
        description:
          '<p>Fortune examined the top debt consolidation companies for multiple financial situations. To create our list, we considered the number of customer reviews, each company’s average customer review score, states operated in, and minimum debt suggested or required to work with each company. These factors were weighed and formulated into a star rating on a scale of 1-5.</p>',
        title: 'METHODOLOGY',
      },
      note: "On National Debt Relief's Website",
      popupImage: '/static/ndr/ndr_popup.jpeg',
      primaryCta: {
        text: 'Get Your Free Estimate',
        url: 'https://start.nationaldebtrelief.com/apply',
      },
      reviews: [
        {
          companyLogos: {
            footerCard: '/static/ndr/national-debt-relief-sticky.png',
            reviewCard: '/static/ndr/national-debt-relief.png',
          },
          companyName: 'National Debt Relief',
          companyPhone: '800-940-1328',
          companySlug: 'national-debt-relief',
          ctas: {
            primary: {
              text: 'Learn More',
              url: 'https://start.nationaldebtrelief.com/apply',
            },
            sticky: {
              text: 'Get Started',
              url: 'https://start.nationaldebtrelief.com/apply',
            },
          },
          fullReviewHero: 'https://fortune.com/img-assets/wp-content/uploads/2025/10/Article-Image.png',
          fullReviewProps: [
            'One Low Monthly Payment ',
            'Reduce Multiple Payments to One',
            'Debt Free in 24-48 Months ',
            'Approval in Minutes',
            'Free Consultation & Zero Upfront Fees',
            'BBB A+ Accredited, Largest in the Industry, & Highly Rated Nationwide',
          ],
          infoText: 'On the National Debt Relief website',
          infoTitle: 'Get a free, No-Commitment Savings Estimate',
          optionType: 'Best option',
          ordinal: 1,
          paragraphs: [
            '<p>When it comes to paying off debt, there are plenty of programs out there to help you do it, but the key is finding one that fits your situation. A debt relief program can help you become debt-free with a single, affordable monthly program payment. National Debt Relief is one of the primary options available to consumers. Read below to take a closer look at the services offered via National Debt Relief’s programs.</p>',
            '<h2>What is National Debt Relief?</h2><p>National Debt Relief is a recognized and respected name in debt relief, having helped hundreds of thousands of Americans find relief from debt since 2009. The company’s mission is to help clients regain control of their finances and move forward with confidence. National Debt Relief has earned an “A+” rating from the Better Business Bureau and recognition an ethical, supportive, compassionate approach. </p>',
            '<h2>How it works</h2><p> Working with National Debt Relief begins with a free, no-obligation consultation where a certified debt specialist takes time to understand your unique financial situation. Plans are customized based on income, goals, and total debt, ensuring that clients receive a solution designed around their needs; not a one-size-fits-all program. The team’s focus on zero judgement, empathy, and education aims to let customers know what to expect and feel supported at every step.</p>',
            '<h2>Simplified debt relief process</h2><p> Clients consolidate multiple debts into a single monthly payment. This approach allows clients to focus on consistent progress rather than juggling multiple payments and due dates. The company’s system is designed to make the process as transparent as possible and get clients out of debt in as little as 24-48 months.</p>',
            '<h2>Dedicated support from start to finish</h2><p>National Debt Relief brings a team of experienced and caring professionals to assist clients. From the initial consultation to the completion of your program, the company emphasizes that you’ll work with specialists who prioritize your financial success. Regular updates, clear communication, and honest feedback ensure clients always feel informed and in control. </p>',
            '<h2>Proven results and trusted reputation</h2><p> National Debt Relief’s success is built on trust and measurable outcomes. With more than 500,000 clients helped and billions of dollars in debt paid off, the company stands tall as an effective and reputable debt help provider. Its “A+” BBB rating and numerous industry awards reflect an ongoing commitment to integrity and customer care.</p>',
            '<h2>A leading choice for real financial freedom</h2><p>For anyone struggling with high debt, National Debt Relief offers hope, guidance, and a proven path forward. With a supportive team, transparent process, and strong record of success, National Debt Relief is Fortune’s No. 1 partner for helping consumers work toward lasting financial independence. </p>',
          ],
          reviewLabel: 'Excellent',
          reviewScore: 4.9,
          sticky: true,
          valuesProps: [
            'A+ rating with the Better Business Bureau',
            'Pay Up to 45% Less Than You Owe*',
            'Debt-free in 12-48 Months',
          ],
        },
        {
          companyLogos: {
            footerCard: '',
            reviewCard: '/static/ndr/turbo-debt.png',
          },
          companyName: 'TurboDebt',
          companyPhone: '',
          companySlug: 'turbo-debt',
          ctas: {
            primary: {
              text: 'Learn More',
              url: 'https://www.ab92trk.com/3DJHTWP/XCQZJ/',
            },
            sticky: {
              text: '',
              url: '',
            },
          },
          fullReviewHero: 'https://fortune.com/img-assets/wp-content/uploads/2025/10/Article-Image.png',
          fullReviewProps: [
            'One Personalized Plan',
            'Reduce Your Debt Faster with Expert Negotiation',
            'Simplify Multiple Payments into One',
            'Become Debt-Free in 24–48 Months',
            'Free consultation with no upfront fees',
            'BBB Accredited with Strong Client Satisfaction',
          ],
          infoText: '',
          infoTitle: '',
          optionType: 'Good option',
          ordinal: 2,
          paragraphs: [
            '<p>TurboDebt provides professional debt relief solutions designed to help consumers manage and reduce unsecured debt through customized settlement strategies. Since its founding, the company has assisted thousands of clients nationwide in negotiating lower balances and rebuilding financial stability. TurboDebt’s approach combines hands-on customer support with a results-focused program that aims to deliver meaningful financial relief.</p>',
            '<h2>Personalized, guided process</h2><p> Getting started with TurboDebt is straightforward. Prospective clients complete a free consultation, during which a certified debt specialist reviews their financial situation. Based on income, total debt, and goals, the consultant recommends a customized plan that typically involves negotiating directly with creditors to settle outstanding balances. Clients who opt to move forward will be responsible for making one consolidated monthly payment into a dedicated account that funds these settlements over time.</p>',
            '<h2>Customer-focused service</h2><p>TurboDebt is recognized for its clear communication and attentive service. Advisors explain every step of the process and help clients come to realistic expectations about savings and timelines. Clients often report that the staff are patient, professional, and proactive in helping them stay on track toward financial independence. </p>',
            '<h2>Results and reliability</h2><p>Most participants complete TurboDebt’s program within two to four years, depending on their individual circumstances, according to the company. The company operates on a performance-based model—there are no upfront costs, and fees apply only once a successful settlement is achieved. </p>',
            '<h2>Accredited and transparent</h2><p>TurboDebt is accredited by the Better Business Bureau and has earned strong ratings for its customer experience and ethical business practices. While all debt settlement programs can affect credit scores during the process, TurboDebt takes care to ensure clients understand these effects and are confident in their decision before enrolling. </p>',
            '<h2>Solid choice for debt relief</h2><p>TurboDebt is a dependable option for consumers seeking an organized, professional path to managing unsecured debt. With a personalized approach, no-fee start, and ongoing client support, TurboDebt provides a practical and trustworthy route to long-term financial relief. </p>',
          ],
          reviewLabel: 'Excellent',
          reviewScore: 4.6,
          sticky: false,
          valuesProps: [
            'A+ rating with the Better Business Bureau',
            'Accredited with the American Association for Debt Resolution',
            '4.9-star rating on Trustpilot',
          ],
        },
        {
          companyLogos: {
            footerCard: '',
            reviewCard: '/static/ndr/clearone-advantage.svg',
          },
          companyName: 'ClearOne Advantage',
          companyPhone: '',
          companySlug: 'clearone-advantage',
          ctas: {
            primary: {
              text: 'Learn More',
              url: 'https://www.clm8p4wtrk.com/J84C5/2CTPL/?uid=3',
            },
            sticky: {
              text: '',
              url: '',
            },
          },
          fullReviewHero: 'https://fortune.com/img-assets/wp-content/uploads/2025/10/Article-Image.png',
          fullReviewProps: [
            'One Affordable Monthly Payment',
            'Reduce Debt Without Upfront Fees',
            'Personalized Debt Relief Plans',
            'Debt-Free in as Little as 24–60 Months',
            'Free consultation with performance-based fees',
            'Accredited by the American Fair Credit Council (AFCC) and BBB',
          ],
          infoText: '',
          infoTitle: '',
          optionType: 'Average option',
          ordinal: 7,
          paragraphs: [
            '<p>ClearOne Advantage offers professional debt relief and consolidation services focused on helping consumers reduce unsecured debt through strategic negotiations with creditors. Since its founding in 2008, the company has helped hundreds of thousands of clients regain financial control by developing customized settlement plans tailored to individual budgets and goals.</p>',
            '<h2>Personalized debt resolution plans</h2><p>The process starts with a free consultation where ClearOne Advantage reviews your financial situation, including your debt balances, income, and monthly expenses. From there, a certified debt consultant designs a program that aims to lower the total amount owed and combine multiple debts into one affordable monthly payment. Clients typically deposit funds into a dedicated account that is later used to pay negotiated settlements with creditors. </p>',
            '<h2>Supportive, knowledgeable team</h2><p> ClearOne Advantage is known for its transparency and professionalism. Clients receive one-on-one support throughout the process, with representatives providing updates and education along the way. The company emphasizes clarity—helping clients understand how each step works, the timeline for results, and the probable impact to their credit.</p>',
            '<h2>Proven track record</h2><p> Most ClearOne clients complete the program within two to five years, depending on the size of their enrolled debt and ability to make consistent payments, according to the company. ClearOne operates under a success-based fee structure, meaning no charges are applied until at least one debt is successfully resolved. </p>',
            '<h2>Trusted and accredited</h2><p>ClearOne Advantage maintains an “A+” rating with the Better Business Bureau and is accredited by the American Fair Credit Council (AFCC). This highlights the company’s commitment to strict consumer protection standards and ethical business practices. </p>',
            '<h2>Reliable option for debt relief</h2><p>ClearOne Advantage stands out for its personalized service, transparent process, and strong reputation in the debt consolidation industry. For consumers looking to consolidate debt, ClearOne offers a trusted, results-driven path toward financial freedom. </p>',
          ],
          reviewLabel: 'Average',
          reviewScore: 3.4,
          sticky: false,
          valuesProps: [
            'Proven track record with 15+ years in operation',
            'Has helped clients resolve over $3 billion in debt',
            'Convenient online portal to track your progress',
          ],
        },
        {
          companyLogos: {
            footerCard: '',
            reviewCard: '/static/ndr/debt-blue.svg',
          },
          companyName: 'DebtBlue',
          companyPhone: '',
          companySlug: 'debt-blue',
          ctas: {
            primary: {
              text: 'Learn More',
              url: 'https://urldefense.com/v3/__https://debtblue.com/reviews/?lang=en__;!!GD9uuWclLEIVVNQ!9OWTtZ_CsTc_9naHZlB-Zkuhu_2tbj35DuKcV0_8thlIwUYQiVDN9juTFxoqs-kaa4SS1wZXS8n3e29UgAyqoKoviyALBod7EZ-bpQ$',
            },
            sticky: {
              text: '',
              url: '',
            },
          },
          fullReviewHero: 'https://fortune.com/img-assets/wp-content/uploads/2025/10/Article-Image.png',
          fullReviewProps: [
            'Personalized Debt Relief Solutions',
            'Lower Monthly Payments and Reduce Debt',
            'Free Consultation with Certified Specialists',
            'Debt-Free in 24–48 Months',
            'No upfront fees; pay only after settlements',
            'BBB Accredited with “A+” Rating',
          ],
          infoText: '',
          infoTitle: '',
          optionType: 'Good option',
          ordinal: 6,
          paragraphs: [
            '<p>DebtBlue provides professional debt relief and settlement services to help consumers overcome unsecured debt such as credit cards, medical bills, and personal loans. Founded in 2018 and based in Texas, the company has quickly built a strong reputation for transparency, client advocacy, and hands-on customer care. DebtBlue’s goal is to help individuals resolve debt faster and rebuild financial confidence without the need for additional loans.</p>',
            '<h2>Tailored financial guidance</h2><p>DebtBlue begins each client relationship with a free consultation to review financial circumstances and determine eligibility. During this call, a certified debt specialist evaluates your income, total debt, and goals to create a plan that fits your budget. The company focuses on negotiating with creditors to settle accounts for less than the full balance owed, reducing overall debt and simplifying payments into one monthly deposit. </p>',
            '<h2>Supportive, transparent service</h2><p>Clients often highlight DebtBlue’s professionalism and communication. Representatives are available to explain the process, provide updates, and help clients stay informed from start to finish. DebtBlue’s team emphasizes education, ensuring you understand how settlement affects your credit, what to expect during negotiations, and how to transition to a stronger financial position once your program is complete. </p>',
            '<h2>Proven results and fair pricing</h2><p>Program timelines vary based on the amount of debt, but most clients see resolution within 24 to 48 months, according to the company. DebtBlue operates on a performance-based model, charging no fees until a debt is successfully settled. This structure aligns their success with client outcomes. </p>',
            '<h2>Trust and recognition</h2><p>DebtBlue holds an “A+” rating and accreditation from the Better Business Bureau, reflecting their commitment to ethical business practices and consumer trust. The company is also a member of respected industry organizations that promote fair and transparent debt resolution standards. </p>',
            '<h2>Dependable choice for debt relief</h2><p> DebtBlue offers a professional and client-focused approach to managing unsecured debt. With no upfront costs, individualized support, and a strong reputation for integrity, DebtBlue is a dependable choice for those seeking to simplify payments, reduce debt, and move toward long-term financial stability.</p>',
          ],
          reviewLabel: 'Very Good',
          reviewScore: 3.9,
          sticky: false,

          valuesProps: [
            'Keeps 170+ experts on staff to assist clients',
            'Explains program fees clearly and transparently',
            'Available in 40 states across the U.S.',
          ],
        },
        {
          companyLogos: {
            footerCard: '',
            reviewCard: '/static/ndr/debt-com.svg',
          },
          companyName: 'Debt.com',
          companyPhone: '',
          companySlug: 'debt-com',
          ctas: {
            primary: {
              text: 'Learn More',
              url: '',
            },
            sticky: {
              text: '',
              url: '',
            },
          },
          fullReviewHero: 'https://fortune.com/img-assets/wp-content/uploads/2025/10/Article-Image.png',
          fullReviewProps: [
            'Your One-Stop Debt Help Resource',
            'Connect with Trusted Financial Experts',
            'Free Matching to Certified Providers',
            'Solutions for Debt, Credit, and Budgeting',
            'Free Consultation and Guidance',
            'Accredited by the Better Business Bureau, Rated “A+”',
          ],
          infoText: '',
          infoTitle: '',
          optionType: 'Average option',
          ordinal: 6,
          paragraphs: [
            '<p>Debt.com operates as an informational and referral platform that connects consumers to reputable financial service providers specializing in debt consolidation, credit counseling, and debt settlement. Founded in 2013, Debt.com serves as a central hub for people seeking trustworthy help to manage debt and improve overall financial health. The company’s mission is to educate, inform, and match users with the right professionals for their unique circumstances.</p>',
            '<h2><Comprehensive financial solutions/h2><p> Rather than offering a single debt relief program, Debt.com partners with a network of certified service providers. These include companies specializing in debt consolidation loans, settlement programs, credit repair, and budget counseling. After a brief assessment of your financial profile, Debt.com’s team recommends the best-fitting service partner—making it a helpful resource for consumers unsure of which path to take.</p>',
            '<h2>Educational and supportive approach</h2><p>Debt.com places strong emphasis on financial education. The site provides tools, calculators, and expert articles that help consumers understand the pros and cons of each debt relief option before taking action. The platform’s specialists can also guide users through the process of connecting with accredited providers and ensure that all recommendations meet strict industry and ethical standards. </p>',
            '<h2>Transparent and consumer-focused</h2><p>The service is free to use, and there are no hidden costs for consultations or referrals. Any fees that apply will come from the partner organization a consumer chooses to work with. This transparency, combined with Debt.com’s editorial oversight and financial expertise, has made it a credible and reliable name in the debt relief industry. </p>',
            '<h2>Reputation and accreditation</h2><p> Debt.com holds an “A+” rating with the Better Business Bureau and is recognized for its commitment to honesty, accuracy, and consumer protection. The organization regularly collaborates with certified nonprofit credit counseling agencies and top-rated financial companies to ensure that clients are referred only to legitimate and ethical providers.</p>',
            '<h2>Trusted financial resource</h2><p>Debt.com stands out as a comprehensive gateway for individuals seeking trusted, well-vetted debt relief and financial improvement options. For consumers unsure where to start or overwhelmed by multiple debts, Debt.com offers clarity, choice, and confidence through its wide network of verified partners. </p>',
          ],
          reviewLabel: 'Average',
          reviewScore: 2.9,
          sticky: false,

          valuesProps: [
            'Assists folks with finding licensed debt relief companies',
            'Operates in all 50 states',
            'A+ Better Business Bureau rating',
          ],
        },
        {
          companyLogos: {
            footerCard: '',
            reviewCard: '/static/ndr/century-support-services.png',
          },
          companyName: 'Century Support Services',
          companyPhone: '',
          companySlug: 'century-support-services',
          ctas: {
            primary: {
              text: 'Learn More',
              url: 'https://go.withcentury.com/v2?wf=1&cid=cp312&fid=2z0ivx&fvid=Siw4iz&pid=cs2953',
            },
            sticky: {
              text: '',
              url: '',
            },
          },
          fullReviewHero: 'https://fortune.com/img-assets/wp-content/uploads/2025/10/Article-Image.png',
          fullReviewProps: [
            'One Simple Monthly Payment',
            'Reduce Debt Through Negotiated Settlements',
            'Personalized Plans with Certified Specialists',
            'Debt-Free in 24–48 Months',
            'No Upfront Fees; Pay Only After Settlements',
            'BBB Accredited with “A+” Rating',
          ],
          infoText: '',
          infoTitle: '',
          optionType: 'Good option',
          ordinal: 5,
          paragraphs: [
            '<p>Century Support Services is a well-established debt settlement company that helps consumers manage and reduce unsecured debt through structured repayment and negotiation programs. Founded in 2012 and headquartered in Pennsylvania, Century has helped hundreds of thousands of clients settle more than a billion dollars in debt. Their approach focuses on combining professional financial counseling with clear communication and realistic expectations.</p>',
            '<h2>Customized debt relief approach</h2><p>Century begins with a free financial consultation designed to assess your current debt obligations, income, and ability to save toward settlements. A certified debt consultant then creates a personalized plan, consolidating multiple unsecured debts into one monthly deposit. These funds are used to negotiate settlements with creditors for less than the total owed, allowing clients to resolve debt more quickly than through minimum payments. </p>',
            '<h2>Professional, compassionate service</h2><p>Representatives from Century Support Services take time to explain how the process works, discuss probable impacts to credit, and provide consistent updates as settlements progress. Many clients highlight the company’s professionalism, transparency, and commitment to helping them stay informed throughout the journey. </p>',
            '<h2>Program performance and duration</h2><p>Depending on the amount of debt enrolled and the client’s ability to make consistent payments, most Century programs last between two and four years. The company follows a success-based fee structure, charging only after a debt is successfully settled. This aligns their incentives with client outcomes. </p>',
            '<h2>Strong reputation and industry trust</h2><p>Century Support Services maintains an “A+” rating with the Better Business Bureau and accreditation from the American Fair Credit Council (AFCC). This highlights a dedication to ethical practices and adherence to industry standards that protect consumers. </p>',
            '<h2>Reliable choice for debt settlement</h2><p> Century Support Services is a trusted option for consumers seeking a structured and reliable path out of unsecured debt. With a decade of experience, professional guidance, and a no-upfront-fee model, Century offers a proven solution for those looking to regain control of their finances and achieve lasting relief.</p>',
          ],
          reviewLabel: 'Great',
          reviewScore: 4.0,
          sticky: false,

          valuesProps: [
            'Has helped clients settle over $2 billion in debt',
            'More than 297,000 clients served since 2003',
            'A+ Better Business Bureau rating',
          ],
        },
        {
          companyLogos: {
            footerCard: '',
            reviewCard: '/static/ndr/money-management-international.svg',
          },
          companyName: 'Money Management International (MMI)',
          companyPhone: '',
          companySlug: 'money-management-international',
          ctas: {
            primary: {
              text: 'Learn More',
              url: '',
            },
            sticky: {
              text: '',
              url: '',
            },
          },
          fullReviewHero: 'https://fortune.com/img-assets/wp-content/uploads/2025/10/Article-Image.png',
          fullReviewProps: [
            'Nonprofit Credit Counseling Services',
            'Lower Interest Rates and Monthly Payments',
            'Certified Financial Education and Coaching',
            'Debt Management Plans Available Nationwide',
            'Free Consultation; Modest Monthly Program Fees',
            'Accredited by the NFCC and BBB “A+” Rated',
          ],
          infoText: '',
          infoTitle: '',
          optionType: 'Average option',
          ordinal: 10,
          paragraphs: [
            '<p>Money Management International (MMI) is one of the nation’s largest and most respected nonprofit credit counseling agencies. Founded in 1958, MMI specializes in helping consumers regain control of their finances through education, personalized budgeting, and structured debt management plans (DMPs). Unlike for-profit settlement companies, MMI’s focus is on teaching long-term money management skills while reducing interest rates and consolidating payments into one manageable monthly amount.</p>',
            '<h2>Comprehensive financial counseling</h2><p>MMI begins with a free credit counseling session conducted by a certified financial counselor. During this session, clients review income, expenses, and debts to identify the best path forward. If a debt management plan is appropriate, MMI works directly with creditors to lower interest rates and eliminate late fees, often helping clients pay off debt in three to five years. </p>',
            '<h2>Nonprofit approach and educational support</h2><p> As a nonprofit organization, MMI places strong emphasis on consumer education. Their counselors offer tools and resources to help clients develop better budgeting habits and avoid future debt. The organization also provides housing counseling, student loan guidance, and financial literacy programs to promote overall financial well-being.</p>',
            '<h2>Structured debt management plans</h2><p>Through MMI’s DMP, clients make a single monthly payment that is distributed to creditors on their behalf. This approach can simplify debt repayment while potentially saving thousands of dollars in interest over time. There are no upfront fees for consultations, and monthly program costs are modest and regulated by state laws. </p>',
            '<h2>Trusted and accredited</h2><p>MMI is accredited by the National Foundation for Credit Counseling (NFCC) and the Council on Accreditation (COA). It also maintains an “A+” rating with the Better Business Bureau. These designations reflect the organization’s commitment to ethical standards, transparency, and high-quality financial counseling. </p>',
            '<h2>Ideal choice for education-based debt relief</h2><p>Money Management International is best suited for consumers seeking structured, long-term solutions rather than quick settlements. With its nonprofit foundation, educational mission, and proven success helping clients reduce interest and pay off debt, MMI remains one of the most trusted names in consumer credit counseling. </p>',
          ],
          reviewLabel: 'Average',
          reviewScore: 2.9,
          sticky: false,

          valuesProps: [
            'May be able to help clients become debt-free up to 7X faster',
            'More than 2.5 million people counseled',
            'Potential interest rate reductions by as much as 75%',
          ],
        },
        {
          companyLogos: {
            footerCard: '',
            reviewCard: '/static/ndr/pacific-debt-relief.svg',
          },
          companyName: 'Pacific Debt Relief',
          companyPhone: '',
          companySlug: 'pacific-debt-relief',
          ctas: {
            primary: {
              text: 'Learn More',
              url: 'https://www.pacificdebt.com/free-consultation-ndr',
            },
            sticky: {
              text: '',
              url: '',
            },
          },
          fullReviewHero: 'https://fortune.com/img-assets/wp-content/uploads/2025/10/Article-Image.png',
          fullReviewProps: [
            'One Affordable Monthly Program',
            'Reduce Debt Without a New Loan',
            'Free Consultation with Certified Experts',
            'Debt-Free in 24–48 Months',
            'No Upfront Fees',
            'BBB Accredited with “A+” Rating',
          ],
          infoText: '',
          infoTitle: '',
          optionType: 'Good option',
          ordinal: 3,
          paragraphs: [
            '<p>Pacific Debt Relief is a long-established debt settlement company that helps consumers manage and reduce unsecured debt through professional negotiation and structured repayment programs. Founded in 2002 and based in California, Pacific Debt Relief has earned recognition as one of the more experienced and client-focused companies in the industry, having helped thousands of customers resolve millions in unsecured debt.</p>',
            '<h2>Tailored debt relief solutions</h2><p>The process begins with a free consultation, during which a certified debt consultant reviews your financial situation to determine if settlement is a suitable option. Once enrolled, you make a single monthly deposit into a dedicated account while Pacific’s team negotiates directly with creditors to reduce your balances. This approach allows clients to consolidate payments, lower total debt, and work toward financial independence without taking on new loans. </p>',
            '<h2>Client-focused guidance</h2><p>Pacific Debt Relief places strong emphasis on personalized service and education. Their specialists are known for clear communication and realistic expectations, ensuring each client understands the process, potential savings, and effects on credit. Reviews often highlight the company’s professionalism, transparency, and consistent follow-up throughout the program. </p>',
            '<h2>Results and program timeline</h2><p>Most Pacific Debt Relief clients complete their programs in two to four years, depending on the amount of debt enrolled and the pace of contributions, according to the company. Pacific Debt Relief operates on a performance-based fee structure, which means there are no upfront costs—fees are only applied after a successful settlement is reached. </p>',
            '<h2>Trusted reputation and accreditation</h2><p>Pacific Debt Relief maintains accreditation with the Better Business Bureau and holds an “A+” rating for its customer service and ethical practices. It is also a member of the American Fair Credit Council (AFCC), which requires strict adherence to consumer protection standards and transparent fee disclosures. </p>',
            '<h2>Respected leader in debt consolidation</h2><p>Pacific Debt Relief is a proven and trustworthy option for consumers struggling with unsecured debt who prefer a structured, hands-on approach. With its strong reputation, client-first philosophy, and success-based pricing, Pacific stands out as a reliable path to reducing debt and achieving long-term financial stability. </p>',
          ],
          reviewLabel: 'Great',
          reviewScore: 4.2,
          sticky: false,

          valuesProps: [
            'In operation since 2002',
            'May be able to reduce credit card balance by up to half',
            'Resolve your debt without taking out new loans',
          ],
        },
        {
          companyLogos: {
            footerCard: '',
            reviewCard: '/static/ndr/debthelp-com.png',
          },
          companyName: 'Debt.Help',
          companyPhone: '',
          companySlug: 'debthelp-com',
          ctas: {
            primary: {
              text: 'Learn More',
              url: 'https://max.debt.help/?_ef_transaction_id=&affid=31&oid=2&transaction_id=',
            },
            sticky: {
              text: '',
              url: '',
            },
          },
          fullReviewHero: 'https://fortune.com/img-assets/wp-content/uploads/2025/10/Article-Image.png',
          fullReviewProps: [
            'One Source for Debt Relief Options',
            'Compare Consolidation and Settlement Programs',
            'Free Consultation and Educational Resources',
            'Trusted Network of Certified Partners',
            'No Fees for Initial Matching or Guidance',
            'BBB Accredited Resource Hub',
          ],
          infoText: '',
          infoTitle: '',
          optionType: 'Good option',
          ordinal: 4,
          paragraphs: [
            '<p>DebtHelp.com operates as a trusted online resource designed to connect consumers with legitimate debt relief and financial counseling providers. Founded in 2000, the company serves as an informational hub where individuals can explore multiple solutions—including debt consolidation, settlement, and credit counseling—before choosing the best approach for their situation. Rather than providing direct services, DebtHelp.com’s mission is to educate and guide consumers toward reliable, accredited partners.</p>',
            '<h2>Comprehensive debt relief matching</h2><p>The process begins with a free, no-obligation consultation or short online form. Based on your financial details—such as total debt, credit score, and income—DebtHelp.com connects you with appropriate service providers. These partners may include settlement companies, credit counseling agencies, or consolidation lenders, allowing users to compare options side by side before making a commitment. </p>',
            '<h2>Educational and transparent approach</h2><p>DebtHelp.com distinguishes itself through its focus on financial literacy. The platform provides in-depth articles, tools, and guides to help users understand how each type of debt relief works, including potential benefits and drawbacks. By providing objective information and emphasizing transparency, the company empowers consumers to make informed financial decisions. </p>',
            '<h2>Free access and no hidden costs</h2><p> There are no fees for consultations or matching services through DebtHelp.com. Any costs associated with debt relief programs are determined by the partner companies clients choose to work with. This open model makes the platform accessible to anyone exploring options to reduce debt or improve financial health.</p>',
            '<h2>Reputation and trustworthiness</h2><p>DebtHelp.com maintains accreditation with the Better Business Bureau and has earned an “A+” rating, reflecting its dedication to accuracy, fairness, and consumer advocacy. The company only partners with reputable, accredited organizations that meet industry standards for ethical conduct and customer care. </p>',
            '<h2>Helpful resource for exploring debt solutions</h2><p>DebtHelp.com is an excellent starting point for consumers unsure of which debt relief option suits them best. With its educational focus, no-cost consultation model, and commitment to connecting users with verified professionals, the site provides a safe, informative gateway to legitimate debt relief services. </p>',
          ],
          reviewLabel: 'Great',
          reviewScore: 4.1,
          sticky: false,

          valuesProps: [
            'Average debt savings of 25% after fees',
            'Adheres to standards of the American Association of Debt Relief and the International Association of Professional Debt Arbitrators',
            'Powered by National Debt Relief',
          ],
        },
        {
          companyLogos: {
            footerCard: '',
            reviewCard: '/static/ndr/new-era-debt-relief.svg',
          },
          companyName: 'New Era Debt Relief',
          companyPhone: '',
          companySlug: 'new-era-debt-relief',
          ctas: {
            primary: {
              text: 'Learn More',
              url: '',
            },
            sticky: {
              text: '',
              url: '',
            },
          },
          fullReviewHero: 'https://fortune.com/img-assets/wp-content/uploads/2025/10/Article-Image.png',
          fullReviewProps: [
            'Personalized Debt Resolution Programs',
            'One Affordable Monthly Payment',
            'Reduce Debt Without Taking on New Loans',
            'Debt-Free in 24–48 Months',
            'Free Consultation and No Upfront Fees',
            'BBB Accredited with Strong Client Reputation',
          ],
          infoText: '',
          infoTitle: '',
          optionType: 'NA',
          ordinal: 7,
          paragraphs: [
            '<p>New Era Debt Relief provides professional debt settlement services to help consumers resolve unsecured debt through strategic negotiation and personalized financial plans. The company’s mission is to make debt relief more transparent and accessible, guiding clients step-by-step toward financial recovery without the burden of new credit obligations.</p>',
            '<h2>Customized financial solutions</h2><p>The process begins with a free consultation in which a certified debt consultant reviews your current financial situation, including income, debts, and budget. From there, New Era Debt Relief designs a plan that consolidates your obligations into one monthly payment while working directly with creditors to reduce total balances. </p>',
            '<h2>Supportive and transparent service</h2><p> Clients often highlight the company’s communication and professionalism. Representatives take time to explain each stage of the process, ensuring clients fully understand potential savings, timelines, and credit impacts. This education-first approach helps build trust and confidence throughout the program.</p>',
            '<h2>Performance-based and goal-oriented</h2><p>New Era Debt Relief follows a no-upfront-fee model, meaning clients only pay after a successful settlement is reached. Most programs last between two and four years, depending on total enrolled debt and payment consistency, according to the company.  </p>',
            '<h2>Reputation and industry standing</h2><p>Accredited by the Better Business Bureau, New Era Debt Relief maintains strong ratings for ethical practices and transparency. The company also aligns with industry standards set by leading debt relief organizations that emphasize consumer protection and fair representation. </p>',
            '<h2>Reliable partner for debt relief</h2><p>With its clear, results-driven programs and strong focus on client education, New Era Debt Relief stands out as a dependable choice for individuals seeking to regain financial control. Its combination of personalized support and no-risk enrollment makes it a trustworthy option for consumers looking for a structured path toward debt freedom. </p>',
          ],
          reviewLabel: 'NA',
          reviewScore: 3,
          sticky: false,
          valuesProps: [
            'Average score of 4.9 stars on Trustpilot',
            'May be able to negotiate 30% - 60% balance reductions',
            'More than 25 years of serving clients',
          ],
        },
      ],
      topCta: {
        text: 'Compare the Top Options',
        url: 'https://www.nationaldebtrelief.com/apply',
      },
      topLandingPageDek:
        '<p>There’s a big number of debt relief programs available in the marketplace. It’s important to partner with the program that best fits your unique financial profile.</p><p>In times where considerable debt is weighing, it can be difficult to find a trustworthy option to help alleviate debt. The options provided below are legitimate debt relief companies with a strong industry reputation.</p>',
      topLandingPageTitle: 'The top 5 picks for debt relief programs',
    },
    google: {
      defaultPhoneNumber: '888-347-7103',
      disclosure: {
        text: 'The Parties acknowledge and agree that (i) the PPC Program Landing Page, and any related webpages as determined by Publisher in its sole and absolute discretion, shall feature a disclosure that states prominently that all Paid Content is “Paid Content”, with an “i” symbol linking to a further explanation, (a “Disclaimer”) and (ii) the placement, formatting and other wording associated with any Disclaimer shall be determined by Publisher in its sole and absolute discretion.',
        title: 'Paid Content',
      },
      faqs: [
        {
          answer:
            'Debt consolidation companies can help you consolidate most unsecured debt like credit cards, medical bills, and collections accounts into a single affordable monthly payment.',
          question: 'What types of debt can debt consolidation companies help with?',
        },
        {
          answer:
            "Debt consolidation can potentially help improve your credit score if you use a personal loan to consolidate revolving debt such as credit card balances, as installment loans don't factor into your credit utilization. Credit utilization accounts for 30% of your overall credit score. Experts typically recommend that you keep your amounts owed to 30% or less. If your utilization is sky-high, your credit score will suffer.",
          question: 'Can debt consolidation help improve my credit score?',
        },
        {
          answer:
            'For a standard debt consolidation loan, you may encounter an origination fee or similar upon account opening.',
          question: 'Are there fees associated with debt consolidation loans?',
        },
        {
          answer:
            "You can consolidate debt without taking out a new loan by requesting a balance transfer to one of your existing credit cards. Just remember that you can't transfer more debt than your card's credit limit can handle.",
          question: 'Can I consolidate debt without taking out a new loan?',
        },
      ],
      faqTitle: 'Debt Consolidation FAQ’s',
      featuredHero: {
        cards: {
          items: [
            {
              iconName: 'creditCard',
              title: 'Credit Cards',
            },
            {
              iconName: 'squareLibrary',
              title: 'Collections',
            },
            {
              iconName: 'banknoteArrowUp',
              title: 'Lines of Credit',
            },
            {
              iconName: 'handCoins',
              title: 'Personal Loans',
            },
            {
              iconName: 'landmark',
              title: 'Repossessions',
            },
            {
              iconName: 'hospital',
              title: 'Medical Bills',
            },
          ],
          subtitle: 'Most unsecured debt may be eligible for a debt consolidation plan.',
          title: 'Debt You May Be Able to Get Help With',
        },
        cta: {
          text: 'Get Your Free Estimate',
          url: 'https://start.nationaldebtrelief.com/apply-loan',
        },
        fullReviewsSubtitle:
          'Lorem ipsum dolor sit amet consectetur. Fermentum gravida vulputate id odio est. Commodo amet nulla egestas felis adipiscing nam aliquet euismod.',
        fullReviewsTitle: 'Debt You May Be Able to Get Help With',
        image: '/static/ndr/featured-hero.jpeg',
        items: [
          {
            iconName: 'bookText',
            subtitle: 'There’s no obligation and you can explore options for your situation.',
            title: 'Submit the form to set up a free consultation with National Debt Relief',
          },
          {
            iconName: 'listTodo',
            subtitle: 'You’ll get an opportunity to review and approve the personalized plan.',
            title: 'National Debt Relief’s team builds a plan to fit your needs and budget',
          },
          {
            iconName: 'chartCandlestick',
            subtitle: 'You’ll get an opportunity to review and approve the personalized plan.',
            title: 'National Debt Relief’s team builds a plan to fit your needs and budget',
          },
        ],

        note: "On National Debt Relief's Website",
        subtitle: 'Connect with an expert and get the help you need',
        title: 'How Debt Consolidation Works',
      },
      footer:
        '<p>Debt consolidation means lumping multiple debts into one, often resulting in an overall lower monthly payment and reduced APR. Debt consolidation companies may sound like a no-brainer—particularly ones that may be able to help you get out of debt. But these programs aren’t powered by magic; expect monthly payments and a 2-7 year commitment to paying off your debt.</p><p>It’s wise to pore over customer service reviews and rankings with sites like the Better Business Bureau. Some companies will also offer credit counseling upon request to help you find an alternative solution </p><i>*The Parties acknowledge and agree that (i) the PPC Program Landing Page, and any related webpages as determined by Publisher in its sole and absolute discretion, shall feature a disclosure that states prominently that all Paid Content is “Paid Content”, with an “i” symbol linking to a further explanation, (a “Disclaimer”) and (ii) the placement, formatting and other wording associated with any Disclaimer shall be determined by Publisher in its sole and absolute discretion. Of all loans featured on this page, the highest APR is 35.99% and the lowest repayment period is 24 months.</i>',
      landingPageDek:
        '<p>Feeling weighed down by credit card balances, medical debt, or other monthly bills? You’re not alone. Debt can feel overwhelming, but the right debt consolidation program can help you regain control and simplify your payments. We reviewed leading debt consolidation programs to help you choose the right option for your financial situation.</p>',
      landingPageTitle: 'Best Debt Consolidation Companies of 2025',
      methodology: {
        description:
          '<p>Fortune examined the top debt consolidation companies for multiple financial situations. To create our list, we considered the number of customer reviews, each company’s average customer review score, states operated in, and minimum debt suggested or required to work with each company. These factors were weighed and formulated into a star rating on a scale of 1-5.</p>',
        title: 'METHODOLOGY',
      },
      note: "On National Debt Relief's Website",
      popupImage: '/static/ndr/ndr_popup.jpeg',
      primaryCta: {
        text: 'Get Your Free Estimate',
        url: 'https://start.nationaldebtrelief.com/apply-loan',
      },
      reviews: [
        {
          companyLogos: {
            footerCard: '/static/ndr/national-debt-relief-sticky.png',
            reviewCard: '/static/ndr/national-debt-relief.png',
          },
          companyName: 'National Debt Relief',
          companyPhone: '888-347-7103',
          companySlug: 'national-debt-relief',
          ctas: {
            primary: {
              text: 'Learn More',
              url: 'https://start.nationaldebtrelief.com/apply-loan',
            },
            sticky: {
              text: 'Get Started',
              url: 'https://start.nationaldebtrelief.com/apply-loan',
            },
          },
          fullReviewProps: [
            'One Low Monthly Payment',
            'Reduce Multiple Payments to One',
            'Debt Free in 24-48 Months ',
            'Approval in Minutes',
            'Free Consultation & Zero Upfront Fees',
            'BBB A+ Accredited, Largest in the Industry, & Highly Rated Nationwide',
          ],
          infoText: 'On the National Debt Relief website',
          infoTitle: 'Get a free, No-Commitment Savings Estimate',
          optionType: 'Best option',
          ordinal: 1,
          paragraphs: [
            '<p>When it comes to paying off debt, there are plenty of programs out there to help you do it, but the key is finding one that fits your situation. A debt consolidation program can help you become debt-free with a single, affordable monthly program payment. National Debt Relief is one of the primary options available to consumers. Read below to take a closer look at the services offered via National Debt Relief’s programs.</p>',
            '<h2>What is National Debt Relief?</h2><p>National Debt Relief is a recognized and respected name in debt consolidation, having helped hundreds of thousands of Americans find relief from debt since 2009. The company’s mission is to help clients regain control of their finances and move forward with confidence. National Debt Relief has earned an “A+” rating from the Better Business Bureau and recognition an ethical, supportive, compassionate approach. </p>',
            '<h2>How it works</h2><p>Working with National Debt Relief begins with a free, no-obligation consultation where a certified debt specialist takes time to understand your unique financial situation. Plans are customized based on income, goals, and total debt, ensuring that clients receive a solution designed around their needs; not a one-size-fits-all program. The team’s focus on zero judgement, empathy, and education aims to let customers know what to expect and feel supported at every step. </p>',
            '<h2>Simplified debt consolidation process</h2><p>Clients consolidate multiple debts into a single monthly payment. This approach allows clients to focus on consistent progress rather than juggling multiple payments and due dates. The company’s system is designed to make the process as transparent as possible and get clients out of debt in as little as 24-48 months. </p>',
            '<h2>Dedicated support from start to finish</h2><p>National Debt Relief brings a team of experienced and caring professionals to assist clients. From the initial consultation to the completion of your program, the company emphasizes that you’ll work with specialists who prioritize your financial success. Regular updates, clear communication, and honest feedback ensure clients always feel informed and in control. </p>',
            '<h2>Proven results and trusted reputation</h2><p> National Debt Relief’s success is built on trust and measurable outcomes. With more than 500,000 clients helped and billions of dollars in debt paid off, the company stands tall as an effective and reputable debt help provider. Its “A+” BBB rating and numerous industry awards reflect an ongoing commitment to integrity and customer care.</p>',
            '<h2>A leading choice for real financial freedom</h2><p>For anyone struggling with high debt, National Debt Relief offers hope, guidance, and a proven path forward. With a supportive team, transparent process, and strong record of success, National Debt Relief is Fortune’s No. 1 partner for helping consumers work toward lasting financial independence. </p>',
          ],
          reviewLabel: 'Excellent',
          reviewScore: 4.9,
          sticky: true,
          valuesProps: [
            'A+ rating with the Better Business Bureau',
            'Reduce Multiple Payments to One',
            'Debt-free in 24-48 Months',
          ],
        },
        {
          companyLogos: {
            footerCard: '',
            reviewCard: '/static/ndr/clearone-advantage.svg',
          },
          companyName: 'ClearOne Advantage',
          companyPhone: '',
          companySlug: 'clear-one-advantage',
          ctas: {
            primary: {
              text: 'Learn More',
              url: 'https://www.clm8p4wtrk.com/J84C5/2CTPL/?uid=3',
            },
            sticky: {
              text: '',
              url: '',
            },
          },
          fullReviewHero: 'https://fortune.com/img-assets/wp-content/uploads/2025/10/Article-Image.png',
          fullReviewProps: [
            'One Affordable Monthly Payment',
            'No Upfront Fees',
            'Personalized Debt Consolidation Plans',
            'Debt-Free in as Little as 24–60 Months',
            'Free consultation',
            'Accredited by the American Fair Credit Council (AFCC) and BBB',
          ],
          infoText: '',
          infoTitle: '',
          optionType: 'Average option',
          ordinal: 7,
          paragraphs: [
            '<p>ClearOne Advantage offers professional debt consolidation services focused on helping consumers deal with unsecured debt through strategic consolidation. Since its founding in 2008, the company has helped hundreds of thousands of clients regain financial control by developing customized plans tailored to individual budgets and goals. </p>',
            '<h2>Personalized debt consolidation plans</h2><p>The process starts with a free consultation where ClearOne Advantage reviews your financial situation, including your debt balances, income, and monthly expenses. From there, a certified debt consultant designs a program that aims to combine multiple debts into one affordable monthly payment. </p>',
            '<h2>Supportive, knowledgeable team</h2><p>ClearOne Advantage is known for its transparency and professionalism. Clients receive one-on-one support throughout the process, with representatives providing updates and education along the way. The company emphasizes clarity, helping clients understand how each step works, the timeline for results, and the probable impact to their credit.</p>',
            '<h2>Proven track record</h2><p>Most ClearOne clients complete the program within two to five years, depending on the size of their enrolled debt and ability to make consistent payments, according to the company. ClearOne charges no fees upfront—customers pay after approving and enrolling in a plan and making the first payment toward their program. </p>',
            '<h2>Trusted and accredited</h2><p>ClearOne Advantage maintains an “A+” rating with the Better Business Bureau and is accredited by the American Fair Credit Council (AFCC). This highlights the company’s commitment to strict consumer protection standards and ethical business practices.</p>',
            '<h2>Reliable option for debt consolidation</h2><p>ClearOne Advantage stands out for its personalized service, transparent process, and strong reputation in the debt consolidation industry. For consumers looking to consolidate debt, ClearOne offers a trusted, results-driven path toward financial freedom.</p>',
          ],
          reviewLabel: 'Average',
          reviewScore: 3.4,
          sticky: false,

          valuesProps: [
            'Proven track record with 15+ years in operation',
            'Has helped clients with over $3 billion in debt',
            'Convenient online portal to track your progress',
          ],
        },
        {
          companyLogos: {
            footerCard: '',
            reviewCard: '/static/ndr/debt-blue.svg',
          },
          companyName: 'DebtBlue',
          companyPhone: '',
          companySlug: 'debt-blue',
          ctas: {
            primary: {
              text: 'Learn More',
              url: 'https://urldefense.com/v3/__https://debtblue.com/reviews/?lang=en__;!!GD9uuWclLEIVVNQ!9OWTtZ_CsTc_9naHZlB-Zkuhu_2tbj35DuKcV0_8thlIwUYQiVDN9juTFxoqs-kaa4SS1wZXS8n3e29UgAyqoKoviyALBod7EZ-bpQ$',
            },
            sticky: {
              text: '',
              url: '',
            },
          },
          fullReviewHero: 'https://fortune.com/img-assets/wp-content/uploads/2025/10/Article-Image.png',
          fullReviewProps: [
            'Personalized Debt Consolidation Solutions',
            'Lower Monthly Payments ',
            'Free Consultation with Certified Specialists',
            'Debt-Free in ~4 Years',
            'No upfront fees',
            'BBB Accredited with “A+” Rating',
          ],
          infoText: '',
          infoTitle: '',
          optionType: 'Good option',
          ordinal: 6,
          paragraphs: [
            '<p>DebtBlue provides professional debt consolidation services to help consumers overcome unsecured debt such as credit cards, medical bills, and personal loans. Founded in 2018 and based in Texas, the company has quickly built a strong reputation for transparency, client advocacy, and hands-on customer care. DebtBlue’s goal is to help individuals get out of debt faster and rebuild financial confidence.</p>',
            '<h2>Tailored financial guidance</h2><p>DebtBlue begins each client relationship with a free consultation to review financial circumstances and determine eligibility. During this call, a certified debt specialist evaluates your income, total debt, and goals to create a plan that fits your budget. The company focuses on simplifying payments into one manageable monthly amount. </p>',
            '<h2>Supportive, transparent service</h2><p>Clients often highlight DebtBlue’s professionalism and communication. Representatives are available to explain the process, provide updates, and help clients stay informed from start to finish. DebtBlue’s team emphasizes education, ensuring you understand how debt consolidation affects your credit, what to expect during the process, and how to transition to a stronger financial position once your program is complete. </p>',
            '<h2>Proven results and fair pricing</h2><p>Program timelines vary based on the amount of debt, but most clients see completion within four years, according to the company. </p>',
            '<h2>Trust and recognition</h2><p>DebtBlue holds an “A+” rating and accreditation from the Better Business Bureau, reflecting their commitment to ethical business practices. The company is also a member of industry organizations which aim to promote fairness and transparency. </p>',
            '<h2>Dependable choice for debt consolidation</h2><p>DebtBlue offers a professional and client-focused approach to managing unsecured debt. With no upfront costs, individualized support, and a strong reputation for integrity, DebtBlue is a dependable choice for those seeking to simplify payments, consolidate debt, and move toward long-term financial stability. </p>',
          ],
          reviewLabel: 'Very Good',
          reviewScore: 3.9,
          sticky: false,

          valuesProps: [
            'Keeps 170+ experts on staff to assist clients',
            'Explains program fees clearly and transparently',
            'Available in 40 states across the U.S.',
          ],
        },
        {
          companyLogos: {
            footerCard: '',
            reviewCard: '/static/ndr/debt-com.svg',
          },
          companyName: 'Debt.com',
          companyPhone: '',
          companySlug: 'debt-com',
          ctas: {
            primary: {
              text: 'Learn More',
              url: '',
            },
            sticky: {
              text: '',
              url: '',
            },
          },
          fullReviewHero: 'https://fortune.com/img-assets/wp-content/uploads/2025/10/Article-Image.png',
          fullReviewProps: [
            'Your One-Stop Debt Help Resource',
            'Connect with Trusted Financial Experts',
            'Free Matching to Certified Providers',
            'Solutions for Debt, Credit, and Budgeting',
            'Free Consultation and Guidance',
            'Accredited by the Better Business Bureau, Rated “A+”',
          ],
          infoText: '',
          infoTitle: '',
          optionType: 'Average option',
          ordinal: 6,
          paragraphs: [
            '<p>Debt.com operates as an informational and referral platform that connects consumers to reputable financial service providers specializing in debt consolidation and credit counseling. Founded in 2013, Debt.com serves as a central hub for people seeking trustworthy help to manage debt and improve overall financial health. The company’s mission is to educate, inform, and match users with the right professionals for their unique circumstances.</p>',
            '<h2>Comprehensive financial solutions</h2><p>Rather than offering a single debt program, Debt.com partners with a network of certified service providers. These include companies specializing in debt consolidation loans, credit counseling, and budgeting. After a brief assessment of your financial profile, Debt.com’s team recommends the best-fitting service partner, making it a helpful resource for consumers unsure of which path to take. </p>',
            '<h2>Educational and supportive approach</h2><p>Debt.com places strong emphasis on financial education. The site provides tools, calculators, and expert articles that help consumers understand the pros and cons of each debt option before taking action. The platform’s specialists can also guide users through the process of connecting with accredited providers and ensure that all recommendations meet strict industry and ethical standards. </p>',
            '<h2>Transparent and consumer-focused</h2><p>The service is free to use, and there are no hidden costs for consultations or referrals. Any fees that apply will come from the partner organization a consumer chooses to work with. This transparency, combined with Debt.com’s editorial oversight and financial expertise, has made it a credible and reliable name in the debt space. </p>',
            '<h2>Reputation and accreditation</h2><p>Debt.com holds an “A+” rating with the Better Business Bureau and is recognized for its commitment to honesty, accuracy, and consumer protection. The organization regularly collaborates with certified nonprofit credit counseling agencies and top-rated financial companies to ensure that clients are referred only to legitimate and ethical providers. </p>',
            '<h2>Trusted financial resource</h2><p>Debt.com stands out as a comprehensive gateway for individuals seeking trusted, well-vetted debt consolidation and financial improvement options. For consumers unsure where to start or overwhelmed by multiple debts, Debt.com offers clarity, choice, and confidence through its wide network of verified partners. </p>',
          ],
          reviewLabel: 'Average',
          reviewScore: 2.9,
          sticky: false,

          valuesProps: [
            'Assists folks with finding licensed debt relief companies',
            'Operates in all 50 states',
            'A+ Better Business Bureau rating',
          ],
        },
        {
          companyLogos: {
            footerCard: '',
            reviewCard: '/static/ndr/century-support-services.png',
          },
          companyName: 'Century Support Services',
          companyPhone: '',
          companySlug: 'century-support-services',
          ctas: {
            primary: {
              text: 'Learn More',
              url: 'https://go.withcentury.com/v2?wf=1&cid=cp312&fid=2z0ivx&fvid=Siw4iz&pid=cs2953',
            },
            sticky: {
              text: '',
              url: '',
            },
          },
          fullReviewHero: 'https://fortune.com/img-assets/wp-content/uploads/2025/10/Article-Image.png',
          fullReviewProps: [
            'One Simple Monthly Payment',
            'Pay off Debt Through Custom Plans',
            'Speak with Certified Specialists',
            'Debt-Free in about 4 years',
            'No Upfront Fees',
            'BBB Accredited with “A+” Rating',
          ],
          infoText: '',
          infoTitle: '',
          optionType: 'Good option',
          ordinal: 5,
          paragraphs: [
            '<p>Century Support Services is a well-established debt consolidation company that helps consumers manage unsecured debt through structured loan programs. Founded in 2012 and headquartered in Pennsylvania, Century has helped hundreds of thousands of clients with more than a billion dollars in debt. Their approach focuses on combining professional financial counseling with clear communication and realistic expectations.</p>',
            '<h2>Customized debt consolidation approach</h2><p>Century begins with a free financial consultation designed to assess your current debt obligations, income, and ability to save toward paying down debt. A certified debt consultant then creates a personalized plan, consolidating multiple unsecured debts into one monthly payment. </p>',
            '<h2>Professional, compassionate service</h2><p> Representatives from Century Support Services take time to explain how the process works, discuss probable impacts to credit, and provide consistent updates as progress is made. Many clients highlight the company’s professionalism, transparency, and commitment to helping them stay informed throughout the journey.</p>',
            '<h2>Program performance and duration</h2><p>Depending on the amount of debt enrolled and the client’s ability to make consistent payments, most Century programs last between two and four years. The company charges no upfront fees. </p>',
            '<h2>Strong reputation and industry trust</h2><p>Century Support Services maintains an “A+” rating with the Better Business Bureau and accreditation from the American Fair Credit Council (AFCC). This highlights a dedication to ethical practices and adherence to industry standards that protect consumers. </p>',
            '<h2>Reliable choice for debt consolidation</h2><p>Century Support Services is a trusted option for consumers seeking a structured and reliable path out of debt. With a decade of experience, professional guidance, and a no-upfront-fee model, Century offers a proven solution for those looking to regain control of their finances and achieve lasting relief. </p>',
          ],
          reviewLabel: 'Great',
          reviewScore: 4.0,
          sticky: false,

          valuesProps: [
            'Has helped clients with over $2 billion in debt',
            'More than 297,000 clients served since 2003',
            'A+ Better Business Bureau rating',
          ],
        },
        {
          companyLogos: {
            footerCard: '',
            reviewCard: '/static/ndr/money-management-international.svg',
          },
          companyName: 'Money Management International (MMI)',
          companyPhone: '',
          companySlug: 'money-management-international',
          ctas: {
            primary: {
              text: 'Learn More',
              url: '',
            },
            sticky: {
              text: '',
              url: '',
            },
          },
          fullReviewHero: 'https://fortune.com/img-assets/wp-content/uploads/2025/10/Article-Image.png',
          fullReviewProps: [
            'Nonprofit Credit Counseling Service',
            'Lower Interest Rates and Monthly Payments',
            'Certified Financial Education and Coaching',
            'Debt Management Plans Available Nationwide',
            'Free Consultation; Modest Monthly Program Fees',
            'Accredited by the NFCC and BBB “A+” Rated',
          ],
          infoText: '',
          infoTitle: '',
          optionType: 'Average option',
          ordinal: 11,
          paragraphs: [
            '<p>Money Management International (MMI) is one of the nation’s largest and most respected nonprofit credit counseling agencies. Founded in 1958, MMI specializes in helping consumers regain control of their finances through education, personalized budgeting, and structured debt management plans (DMPs). Unlike for-profit companies, MMI’s focus is on teaching long-term money management skills while reducing interest rates and consolidating payments into one manageable monthly amount.</p>',
            '<h2>Comprehensive financial counseling</h2><p>MMI begins with a free credit counseling session conducted by a certified financial counselor. During this session, clients review income, expenses, and debts to identify the best path forward. If a debt management plan is appropriate, MMI works directly with creditors to lower interest rates and eliminate late fees, often helping clients pay off debt in three to five years. </p>',
            '<h2>Nonprofit approach and educational support</h2><p> As a nonprofit organization, MMI places strong emphasis on consumer education. Their counselors offer tools and resources to help clients develop better budgeting habits and avoid future debt. The organization also provides housing counseling, student loan guidance, and financial literacy programs to promote overall financial well-being.</p>',
            '<h2>Structured debt management plans</h2><p>Through MMI’s DMP, clients make a single monthly payment that is distributed to creditors on their behalf. This approach can simplify debt repayment while potentially saving thousands of dollars in interest over time. There are no upfront fees for consultations, and monthly program costs are modest and regulated by state laws. </p>',
            '<h2>Trusted and accredited</h2><p>MMI is accredited by the National Foundation for Credit Counseling (NFCC) and the Council on Accreditation (COA). It also maintains an “A+” rating with the Better Business Bureau. These designations reflect the organization’s commitment to ethical standards, transparency, and high-quality financial counseling. </p>',
            '<h2>Ideal choice for education-based debt help</h2><p>Money Management International is best suited for consumers seeking structured, long-term solutions rather than quick fixes. With its nonprofit foundation, educational mission, and proven success helping clients reduce interest and pay off debt, MMI remains one of the most trusted names in consumer credit counseling. </p>',
          ],
          reviewLabel: 'Average',
          reviewScore: 2.9,
          sticky: false,

          valuesProps: [
            'May be able to help clients become debt-free up to 7X faster',
            'More than 2.5 million people counseled',
            'Potential interest rate reductions by as much as 75%',
          ],
        },
        {
          companyLogos: {
            footerCard: '',
            reviewCard: '/static/ndr/pacific-debt-relief.svg',
          },
          companyName: 'Pacific Debt Relief',
          companyPhone: '',
          companySlug: 'pacific-debt-relief',
          ctas: {
            primary: {
              text: 'Learn More',
              url: 'https://www.pacificdebt.com/free-consultation-ndr',
            },
            sticky: {
              text: '',
              url: '',
            },
          },
          fullReviewHero: 'https://fortune.com/img-assets/wp-content/uploads/2025/10/Article-Image.png',
          fullReviewProps: [
            'One Affordable Monthly Program',
            'Help Paying Off Debt',
            'Free Consultation with Certified Experts',
            'Debt-Free in 2-4 Years',
            'No Upfront Fees',
            'BBB Accredited with “A+” Rating',
          ],
          infoText: '',
          infoTitle: '',
          optionType: 'Good option',
          ordinal: 3,
          paragraphs: [
            '<p>Pacific Debt Relief is a long-established debt consolidation company that helps consumers manage debt through professional consolidation programs. Founded in 2002 and based in California, Pacific Debt Relief has earned recognition as one of the more experienced and client-focused companies in the industry, having helped thousands of customers with millions in unsecured debt.</p>',
            '<h2>Tailored debt consolidation solutions</h2><p>The process begins with a free consultation, during which a certified debt consultant reviews your financial situation to determine if the program is a suitable option. Once enrolled, you make a single monthly payment. This approach allows clients to consolidate payments and work toward financial independence. </p>',
            '<h2>Client-focused guidance</h2><p>Pacific Debt Relief places strong emphasis on personalized service and education. Their specialists are known for clear communication and realistic expectations, ensuring each client understands the process, potential savings, and effects on credit. Reviews often highlight the company’s professionalism, transparency, and consistent follow-up throughout the program. </p>',
            '<h2>Results and program timeline</h2><p>Most Pacific Debt Relief clients complete their programs in two to four years, depending on the amount of debt enrolled and the pace of contributions, according to the company. Pacific Debt Relief operates without any upfront costs. </p>',
            '<h2>Trusted reputation and accreditation</h2><p> Pacific Debt Relief maintains accreditation with the Better Business Bureau and holds an “A+” rating for its customer service and ethical practices. It is also a member of the American Fair Credit Council (AFCC), which requires strict adherence to consumer protection standards and transparent fee disclosures.</p>',
            '<h2>Respected leader in debt consolidation</h2><p> Pacific Debt Relief is a proven and trustworthy option for consumers struggling with unsecured debt who prefer a structured, hands-on approach. With its strong reputation, client-first philosophy, and no upfront fees, Pacific stands out as a reliable path to paying down debt and achieving long-term financial stability.</p>',
          ],
          reviewLabel: 'Great',
          reviewScore: 4.2,
          sticky: false,

          valuesProps: [
            'In operation since 2002',
            'Can help you save thousands',
            'Deal with your debt without taking out new cards',
          ],
        },
        {
          companyLogos: {
            footerCard: '',
            reviewCard: '/static/ndr/debthelp-com.png',
          },
          companyName: 'Debt.Help',
          companyPhone: '',
          companySlug: 'debthelp-com',
          ctas: {
            primary: {
              text: 'Learn More',
              url: 'https://max.debt.help/?_ef_transaction_id=&affid=31&oid=2&transaction_id=',
            },
            sticky: {
              text: '',
              url: '',
            },
          },
          fullReviewHero: 'https://fortune.com/img-assets/wp-content/uploads/2025/10/Article-Image.png',
          fullReviewProps: [
            'One Source for Debt Help Options',
            'Compare Consolidation Programs',
            'Free Consultation and Educational Resources',
            'Trusted Network of Certified Partners',
            'No Fees for Initial Matching or Guidance',
            'BBB Accredited Resource Hub',
          ],
          infoText: '',
          infoTitle: '',
          optionType: 'Good option',
          ordinal: 4,
          paragraphs: [
            '<p>DebtHelp.com operates as a trusted online resource designed to connect consumers with legitimate debt consolidation and financial counseling providers. Founded in 2000, the company serves as an informational hub where individuals can explore multiple solutions (including debt consolidation and credit counseling) before choosing the best approach for their situation. Rather than providing direct services, DebtHelp.com’s mission is to educate and guide consumers toward reliable, accredited partners.</p>',
            '<h2>Comprehensive debt help matching</h2><p>The process begins with a free, no-obligation consultation or short online form. Based on your financial details such as total debt, credit score, and income, DebtHelp.com connects you with appropriate service providers. These partners may include consolidation companies, credit counseling agencies, or other options, allowing users to compare options side by side before making a commitment. </p>',
            '<h2>Educational and transparent approach</h2><p>DebtHelp.com distinguishes itself through its focus on financial literacy. The platform provides in-depth articles, tools, and guides to help users understand how each type of debt option works, including potential benefits and drawbacks. By providing objective information and emphasizing transparency, the company empowers consumers to make informed financial decisions. </p>',
            '<h2>Free access and no hidden costs</h2><p>There are no fees for consultations or matching services through DebtHelp.com. Any costs associated with debt consolidation programs are determined by the partner companies clients choose to work with. This open model makes the platform accessible to anyone exploring options to deal with debt or improve financial health. </p>',
            '<h2>Reputation and trustworthiness</h2><p>DebtHelp.com maintains accreditation with the Better Business Bureau and has earned an “A+” rating, reflecting its dedication to accuracy, fairness, and consumer advocacy. The company only partners with reputable, accredited organizations that meet industry standards for ethical conduct and customer care. </p>',
            '<h2>Helpful resource for exploring debt solutions</h2><p>DebtHelp.com is an excellent starting point for consumers unsure of which debt option suits them best. With its educational focus, no-cost consultation model, and commitment to connecting users with verified professionals, the site provides a safe, informative gateway to legitimate debt consolidation services. </p>',
          ],
          reviewLabel: 'Great',
          reviewScore: 4.1,
          sticky: false,

          valuesProps: [
            'Average debt savings of 25% after fees',
            'Adheres to standards of the AADR and the IAPDA',
            'Powered by National Debt Relief',
          ],
        },
        {
          companyLogos: {
            footerCard: '',
            reviewCard: '/static/ndr/new-era-debt-relief.svg',
          },
          companyName: 'New Era Debt Relief',
          companyPhone: '',
          companySlug: 'new-era-debt-relief',
          ctas: {
            primary: {
              text: 'Learn More',
              url: '',
            },
            sticky: {
              text: '',
              url: '',
            },
          },
          fullReviewHero: 'https://fortune.com/img-assets/wp-content/uploads/2025/10/Article-Image.png',
          fullReviewProps: [
            'Personalized Debt Help Programs',
            'One Affordable Monthly Payment',
            'Deal With Debt Without Bankruptcy',
            'Debt-Free in 4 Years or Less',
            'Free Consultation and No Upfront Fees',
            'BBB Accredited with Strong Client Reputation',
          ],
          infoText: '',
          infoTitle: '',
          optionType: 'Average option',
          ordinal: 7,
          paragraphs: [
            '<p>New Era Debt Relief provides professional debt consolidation services to help consumers deal with unsecured debt through personalized financial plans. The company’s mission is to make debt consolidation more transparent and accessible, guiding clients step-by-step toward financial recovery without the burden of new credit obligations.</p>',
            '<h2>Customized financial solutions</h2><p> The process begins with a free consultation in which a certified debt consultant reviews your current financial situation, including income, debts, and budget. From there, New Era Debt Relief designs a plan that consolidates your obligations into one monthly payment.</p>',
            '<h2>Supportive and transparent service</h2><p>Clients often highlight the company’s communication and professionalism. Representatives take time to explain each stage of the process, ensuring clients fully understand potential savings, timelines, and likely credit impacts. This education-first approach helps build trust and confidence throughout the program. </p>',
            '<h2>Performance-based and goal-oriented</h2><p>New Era Debt Relief follows a no-upfront-fee model, charging a performance-based fee when a debt is settled. Most programs last four years or less, depending on total enrolled debt and payment consistency, according to the company.  </p>',
            '<h2>Reputation and industry standing</h2><p>Accredited by the Better Business Bureau, New Era Debt Relief maintains strong ratings for ethical practices and transparency. The company also aligns with industry standards set by leading debt organizations that emphasize consumer protection and fair representation. </p>',
            '<h2>Reliable partner for debt consolidation</h2><p> With its clear, results-driven programs and strong focus on client education, New Era Debt Relief stands out as a dependable choice for individuals seeking to regain financial control. Its combination of personalized support and no-risk enrollment makes it a trustworthy option for consumers looking for a structured path toward debt freedom.</p>',
          ],
          reviewLabel: 'Average',
          reviewScore: 3,
          sticky: false,

          valuesProps: [
            'Average score of 4.9 stars on Trustpilot',
            'May be able to negotiate 30% - 60% balance reductions',
            'More than 25 years of serving clients',
          ],
        },
        {
          companyLogos: {
            footerCard: '',
            reviewCard: '/static/ndr/turbo-debt.png',
          },
          companyName: 'TurboDebt',
          companyPhone: '',
          companySlug: 'turbo-debt',
          ctas: {
            primary: {
              text: 'Learn More',
              url: 'https://www.ab92trk.com/3DJHTWP/XCQZJ/',
            },
            sticky: {
              text: '',
              url: '',
            },
          },
          fullReviewHero: 'https://fortune.com/img-assets/wp-content/uploads/2025/10/Article-Image.png',
          fullReviewProps: [
            'One Personalized Plan',
            'Become Debt-Free Faster with Experts',
            'Simplify Multiple Payments into One',
            'Become Debt-Free in 24–48 Months',
            'Free consultation with no upfront fees',
            'BBB Accredited with Strong Client Satisfaction',
          ],
          infoText: '',
          infoTitle: '',
          optionType: 'Good option',
          ordinal: 2,
          paragraphs: [
            '<p>TurboDebt provides professional debt consolidation solutions designed to help consumers manage unsecured debt through customized programs. Since its founding, the company has assisted thousands of clients nationwide in getting out of debt and rebuilding financial stability. TurboDebt’s approach combines hands-on customer support with a results-focused program that aims to deliver meaningful financial relief.</p>',
            '<h2>Personalized, guided process</h2><p>Getting started with TurboDebt is straightforward. Prospective clients complete a free consultation, during which a certified debt specialist reviews their financial situation. Based on income, total debt, and goals, the consultant recommends a customized debt consolidation plan. Clients who opt to move forward will be responsible for making one consolidated monthly payment until their debts are paid off.</p>',
            '<h2>Customer-focused service</h2><p>TurboDebt is recognized for its clear communication and attentive service. Advisors explain every step of the process and help clients come to realistic expectations about savings and timelines. Clients often report that the staff are patient, professional, and proactive in helping them stay on track toward financial independence. </p>',
            '<h2>Results and reliability</h2><p>Most participants complete TurboDebt’s program within two to four years, depending on their individual circumstances, according to the company. The company charges no upfront fees, taking its payment once clients complete the program.</p>',
            '<h2>Accredited and transparent</h2><p>TurboDebt is accredited by the Better Business Bureau and has earned strong ratings for its customer experience and ethical business practices. While all debt consolidation programs can affect credit scores during the process, TurboDebt takes care to ensure clients understand these effects and are confident in their decision before enrolling.</p>',
            '<h2>Solid choice for debt consolidation</h2><p>TurboDebt is a dependable option for consumers seeking an organized, professional path to managing unsecured debt. With a personalized approach, no-fee start, and ongoing client support, TurboDebt provides a practical and trustworthy route to long-term financial relief.</p>',
          ],
          reviewLabel: 'Excellent',
          reviewScore: 4.6,
          sticky: false,

          valuesProps: [
            'A+ rating with the Better Business Bureau',
            'Accredited with the AADR',
            '4.9-star rating on Trustpilot',
          ],
        },
      ],
      topCta: {
        text: 'Compare the Top Options',
        url: 'https://www.nationaldebtrelief.com/apply-loan',
      },
      topLandingPageDek:
        '<p>There’s a big number of debt consolidation programs available in the marketplace. It’s important to partner with the program that best fits your unique financial profile.</p><p>In times where considerable debt is weighing, it can be difficult to find a trustworthy option to help alleviate debt. The options provided below are legitimate debt consolidation companies with a strong industry reputation.</p>',
      topLandingPageTitle: 'The top 5 picks for debt consolidation programs',
    },
  },
};
